import { Swiper } from './swiper-DSEIACnL.js';
import { P as Pagination } from './pagination-BiRS_VrL.js';
import { A as A11y } from './a11y-CNmE74mL.js';
import { S as SwiperExt } from './swiper-BAqQR4kf.js';
import './utils-CPPFXbqB.js';
import './create-element-if-not-defined-BweCirD8.js';

class UspBlocks extends SwiperExt {
  connectedCallback() {
    this.swiperInstance = new Swiper(this, {
      modules: [Pagination, A11y],
      watchOverflow: true,
      spaceBetween: 16,
      loop: true,
      pagination: {
        el: this.querySelector('.swiper-pagination-blocks'),
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    });
  }
}

customElements.define('usp-blocks', UspBlocks);
